export function parseISODate(isoString?: string) {
  let year = '';
  let month = '';
  let day = '';
  if (isoString) {
    const birthdayMatches = isoString.match(/(\d\d\d\d)-(\d\d)-(\d\d)/);
    if (birthdayMatches) {
      [year, month, day] = Array.from(birthdayMatches).slice(1);
    }
  }
  return { day, month, year };
}



// WEBPACK FOOTER //
// ./src/components/AddressEditor/parseISODate.ts